export default __webpack_public_path__ + "static/media/Indigo_Circle.45e8c298.svg";